import { useContext } from 'react'
import { JobDetailsContext } from './JobDetailsProvider'

export function useJobDetails() {
    const context = useContext(JobDetailsContext)

    if (context === null) {
        throw 'This hook must be used within a <JobDetailsProvider /> Context provider'
    }

    return context
}

export function useJobDetailsEId() {
    const context = useJobDetails()

    return context.EId
}
